document.addEventListener('DOMContentLoaded', () => {

  if (typeof Swiper === 'undefined') return;

  document.querySelectorAll('.swiper').forEach((slider) => {
    

  try {

    new Swiper(slider, {

      slidesPerView: Number(slider.dataset.mobile || 1),
      spaceBetween: Number(slider.dataset.spaceMobile || 0),

      loop: slider.dataset.loop === 'true',
      rewind: slider.dataset.rewind === 'true',
      centeredSlides: slider.dataset.centered === 'true',
      freeMode: slider.dataset.freeMode === 'true',
      autoHeight: slider.dataset.autoHeight === 'true',
      grabCursor: slider.dataset.grabCursor !== 'false',

      speed: Number(slider.dataset.speed || 300),

      mousewheel: slider.dataset.mousewheel === 'true',
      keyboard: slider.dataset.keyboard === 'true',

      effect: slider.dataset.effect || 'slide',

      autoplay: slider.dataset.autoplay === 'true'
        ? {
            delay: Number(slider.dataset.delay || 3000),
            disableOnInteraction: false
          }
        : false,

      pagination:
        slider.dataset.pagination === 'true' &&
        slider.querySelector('.swiper-pagination')
          ? {
              el: slider.querySelector('.swiper-pagination'),
              clickable: true
            }
          : false,

      navigation:
        slider.dataset.navigation === 'true' &&
        slider.querySelector('.swiper-button-next') &&
        slider.querySelector('.swiper-button-prev')
          ? {
              nextEl: slider.querySelector('.swiper-button-next'),
              prevEl: slider.querySelector('.swiper-button-prev')
            }
          : false,

      breakpoints: {
        768: {
          slidesPerView: Number(
            slider.dataset.tablet || slider.dataset.mobile || 1
          ),
          spaceBetween: Number(
            slider.dataset.spaceTablet || slider.dataset.spaceMobile || 0
          )
        },

        1024: {
          slidesPerView: Number(
            slider.dataset.desktop || slider.dataset.tablet || 1
          ),
          spaceBetween: Number(
            slider.dataset.spaceDesktop || slider.dataset.spaceTablet || 0
          )
        }
      }

    });

  } catch (error) {
    console.warn('Swiper init failed:', slider, error);
  }

  });

});